<template>
    <div class="row">
        <div v-for="n in amount" :class="`col-md-${cols}`" :key="n">
            <div class="bk-card-wrap">
                <span class="bk-card bk-card--skeleton">
                    <span class="bk-card-img skeleton"></span>
                    <span class="bk-card-body">
                        <span class="bk-card-title skeleton">&nbsp;</span>
                        <span class="bk-card-text skeleton">&nbsp;</span>
                    </span>
                </span>
                <span class="bk-card-share skeleton"></span>
            </div>
        </div>
    </div>
</template>

<script>
  import skeletonCards from 'src/mixins/skeletonCardsComponent';

  export default {
    mixins: [skeletonCards],
  };
</script>